


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TextArea from '../common/inputs/TextArea.vue';
import Button from '../common/inputs/Button.vue';
import { Comment } from '@/store/modules/processInterfaces';

@Component({
  components: {
    TextArea,
    Button
  }
})
export default class Comments extends Vue {
  maxLength = 140;
  newComment = '';

  @Prop(Boolean) disabled!: boolean;
  @Prop(Array) comments!: Comment[];
  @Watch('comments')
  onCommentsChanged() {
    const commentList = this.$refs['comments-list'] as HTMLElement;
    this.$nextTick(() => {
      commentList.scrollTop = commentList.scrollHeight;
    });
  }

  submit() {
    if (!this.newComment || this.newComment.length > this.maxLength) {
      return;
    }

    this.$emit('submit', this.newComment);
    this.newComment = '';
  }
}
